import { readable as _readable, writable } from "svelte/store";
import { a } from '../../shared/globalState/a';
import { cnv } from "../../libs/canvas-text/src/shared/cnv";
import { trigger as _trigger } from "mousetrap";

import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';





export const stored = writable({
    setMode: (mode) => {
        a.mode = mode;
        a.mode$.next(mode);

        if (!cnv.context) {
            return;
        }
        if (mode === 'select' || mode === 'boundary' || mode === 'networkHeating') {
            cnv.context.canvas.style.cursor = 'pointer';
        }

        else if (mode === 'break') {
            cnv.context.canvas.style.cursor = 'cell'
        }
        else {
            cnv.context.canvas.style.cursor = 'crosshair';
        }
    },
    getMode: () => a.mode,
    tooltip: function tooltip() {
        var tooltipTriggerList = document.querySelectorAll(
            '[data-bs-toggle="tooltip"]',
        );
        [...tooltipTriggerList].map((el) => new bootstrap.Tooltip(el));
    },
    tooltipHide: function () {
        var tooltipTriggerList = document.querySelectorAll(
            '[data-bs-toggle="tooltip"]',
        );
        [...tooltipTriggerList].map(el => new bootstrap.Tooltip(el, { trigger: 'hover' }));
    },
    thicknessList: [
        { v: 1, label: "1 мм" },
        { v: 2, label: "2 мм" },
        { v: 3, label: "3 мм" },
        { v: 4, label: "4 мм" },
        { v: 5, label: "5 мм" },
        { v: 6, label: "6 мм" },
        { v: 7, label: "7 мм" },
        { v: 8, label: "8 мм" },
        { v: 9, label: "9 мм" },
        { v: 10, label: "10 мм" },
        { v: 11, label: "11 мм" },
        { v: 12, label: "12 мм" },
        { v: 13, label: "13 мм" },
        { v: 14, label: "14 мм" },
        { v: 15, label: "15 мм" },
        { v: 16, label: "16 мм" },
        { v: 17, label: "17 мм" },
        { v: 18, label: "18 мм" },
        { v: 19, label: "19 мм" },
        { v: 20, label: "20 мм" },
    ],
    scaleList: [
        { id: '1', v: 200, label: "1:200", selected: false },
        { id: '2', v: 100, label: "1:100", selected: false },
        { id: '3', v: 50, label: "1:50", selected: false },
        { id: '4', v: 25, label: "1:25", selected: false },
        { id: '5', v: 10, label: "1:10", selected: false },
        { id: '6', v: 5, label: "1:5", selected: false },
        { id: '7', v: 1, label: "1:1", selected: false },
        { id: 'x', v: 0, label: "1:0", selected: false },
    ],
    colorPalette: [
        "#000000",
        "#7d7d7d",
        "#870014",
        "#ec1c23",
        "#ff7e26",
        "#fef100",
        "#22b14b",
        "#00a1e7",
        "#3f47cc",
        "#a349a4",
        "#ffffff",
        "#c3c3c3",
        "#b87957",
        "#feaec9",
        "#ffc80d",
        "#eee3af",
        "#b5e61d",
        "#99d9ea",
        "#7092be",
        "#c8bfe7",
    ]
});